import { render, staticRenderFns } from "./AppointmentDeclineConfirm.vue?vue&type=template&id=028992fc&scoped=true&"
import script from "./AppointmentDeclineConfirm.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDeclineConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDeclineConfirm.vue?vue&type=style&index=0&id=028992fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028992fc",
  null
  
)

export default component.exports